import script from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=2d99c4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d99c4a0"]])

export default __exports__